import request from './request';

export async function list(
  name: string,
  courseIds: string[],
  page: number,
  perPage: number,
  sortColumn?: string,
  sortOrder?: string
) {
  return request('GET', '/api/groups', {
    page,
    perPage,
    name,
    courseIds,
    sortColumn,
    sortOrder,
  });
}

export async function create(
  courseId: string,
  type: number,
  studentIds: string[]
) {
  return request('POST', '/api/groups', {
    courseId,
    type,
    studentIds,
  });
}

export async function remove(id: string) {
  return request('DELETE', `/api/groups/${id}`);
}

export async function finished(id: string) {
  return request('POST', `/api/groups/${id}/finished`);
}

export async function getTypes() {
  return request('GET', '/api/groups/types');
}

export async function exportFile(id: string) {
  return request('GET', `/api/groups/${id}/export`);
}

export async function getStudents(id: string): Promise<{ students: any[] }> {
  return request('GET', `/api/groups/${id}/students`);
}

export async function addStudents(
  id: string,
  requestIds: string[],
  studentIds: string[]
) {
  return request('POST', `/api/groups/${id}/students`, {
    requestIds,
    studentIds,
  });
}

export async function removeStudents(id: string, studentIds: string[]) {
  return request('DELETE', `/api/groups/${id}/students`, { studentIds });
}
